var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conbot-iframe-container"},[(_vm.isLoading)?_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),_c('iframe',{attrs:{"src":`${_vm.baseUrl}/signin?token=${encodeURIComponent(_vm.token)}`,"width":"100%","height":"600px","frameborder":"0"},on:{"load":_vm.hideLoader}})])
}
var staticRenderFns = []

export { render, staticRenderFns }